import { Icon, InfoTag, Tooltip } from "@components/library";
import { COLORS, FONTS } from "@constants";
import pluralize from "pluralize";
import styled from "styled-components";

interface Props {
  count: number;
}

const RequestPageFinalistCount = ({ count }: Props) => {
  return (
    <Container>
      <InfoTag textColor={COLORS.HALO_BLUE} backgroundColor={COLORS.BLUE_LIGHT_300} marginLeft="0">
        &nbsp;{count}&nbsp;
      </InfoTag>
      {pluralize("finalist", count)} selected
      <Tooltip
        content={
          <>
            This industry partner selected <b>{count}</b> {pluralize("innovator", count)} as&nbsp;
            {count === 1 ? "a finalist" : "finalists"} for a potential partnership. Finalists and
            industry partners take their next steps, including further evaluation, off of Halo.
          </>
        }
        tooltipWidth="203px"
      >
        <Icon name="Info Small" size="xs" margin="0 0 0 -2px" />
      </Tooltip>
    </Container>
  );
};

export default RequestPageFinalistCount;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  ${FONTS.REGULAR_2};
  color: ${COLORS.NEUTRAL_500};
`;
